/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { appCardListPayoutConfig } from '@pages/PayoutPage/config/appCardList.config';
import { GET_EVENT_LIST } from '@pages/PayoutPage/apis/graphql';

import { Graphql } from '@common/graphql';
import { apiConfig } from '@pages/PayoutPage/config/api.config';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';

import { toHeaderCase } from 'js-convert-case';
import moment from 'moment';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(AppNavigatorService.name);
};

export interface IGetHolderGroupProps {
  offset?: number;
  size?: number;
  criteria?: any;
}

export interface IAppCardListMethods extends IPluginMethodMap {
  getAppCardListProps(args: IGetHolderGroupProps): Promise<any>;
}

export class AppCardListPlugin implements IAgentPlugin {
  readonly methods: IAppCardListMethods;

  constructor() {
    this.methods = {
      getAppCardListProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IGetHolderGroupProps) {
    //return await this.getAppCardList(args);
    return { ...appCardListPayoutConfig };
  }

  private async getAppCardList(args: IGetHolderGroupProps) {
    let _where2: any = [];
    if (args?.criteria?.name) {
      _where2.push({
        column: 'stormName',
        value: [args?.criteria?.name],
        op: 'ContainsCI',
      });
    }
    try {
      let gql = Graphql.withBaseUrl(apiConfig.spacex_gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .query(GET_EVENT_LIST, {
          input: {
            skip: args?.offset ?? 0,
            limit: args?.size ?? 10,
            where: [
              {
                column: 'status',
                value: ['ACTIVE', 'ACCEPTED', 'IN_QUEUE'],
                op: 'In',
              },
              ..._where2,
            ],
          },
        })
        .toPromise();
      if (res?.data?.getListOfCyclone) {
        let _templateData = this.formatHolderGroup(
          res?.data?.getListOfCyclone?.data
        );
        return {
          appCardList: _templateData,
          isEmpty: res?.data?.getListOfCyclone?.data?.length <= 0,
          activePage: res?.data?.getListOfCyclone?.currentPage,
          pageSize: res?.data?.getListOfCyclone?.pageSize,
          totalCount: res?.data?.getListOfCyclone?.totalCount,
          totalPages: res?.data?.getListOfCyclone?.totalPages,
        };
      }
    } catch (err: any) {
      throw err;
    }
  }
  private formatHolderGroup(data: any) {
    console.log('formatHolderGroup =>', data);
    let _appCard = data.map((item: any) => {
      return {
        rowData: item,
        appCardId: item?.eventId,
        appCardImage: item?.logo ?? appCardListPayoutConfig?.logo,
        ribbon: {
          title: item?.status,
          backgroundColor: this.getStatusColor(item?.status),
        },
        appCardTitle: item?.stormName,
        appCardList: item?.payoutEstimate
          ? [
              {
                name: 'Payout Estimate',
                value: item?.payoutEstimate,
              },
            ]
          : null,
        appCardDescription: item?.date
          ? moment(item?.date).format('LLL')
          : null,
      };
    });

    return _appCard;
  }

  private getStatusColor(status: string) {
    switch (status) {
      case 'ACTIVE':
        return '#008640';
      case 'ACCEPTED':
        return '#008640';
      case 'PAID':
        return '#008640';
      case 'IN_QUEUE':
        return '#F0A901';
      default:
        return '#870000';
    }
  }
}
